export default "__VITE_ASSET__CThACeeC__"